import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Replays the "deal-in" entrance whenever the route changes.
 *
 * Direction carries meaning: a PUSH deals content up from below, as if a
 * card were being laid on the table, while a POP (back/forward) lets it
 * settle down from above.
 *
 * Remounting is deliberate — changing `key` is what makes React tear the
 * subtree down so the CSS animation runs again. That makes the choice of
 * key load-bearing: see sectionKey below.
 */

/**
 * Collapses a pathname to the section that owns it.
 *
 * `Welcome` serves both `/dash` and `/dash/spread/:id` and holds the
 * selected spread, the slide position and the drawn cards in local state.
 * Keying on the raw pathname would remount it the instant a spread was
 * picked, throwing that state away mid-animation. Both paths therefore
 * resolve to the same key, so choosing a spread slides rather than reloads.
 */
export const sectionKey = (pathname) => {
    if (pathname.startsWith('/dash/users')) return '/dash/users'
    if (pathname.startsWith('/dash')) return '/dash'
    return pathname
}

const PageTransition = ({ children, transitionKey }) => {
    const { pathname } = useLocation()
    const navigationType = useNavigationType()

    const key = transitionKey ?? pathname
    const dealFrom = navigationType === 'POP' ? '-12px' : '18px'

    return (
        <div
            key={key}
            className="page-transition"
            style={{ '--deal-from': dealFrom }}
        >
            {children}
        </div>
    )
}

export default PageTransition
